import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Cache } from '../../assets/data/cache-key/cache-key';
import { ConfigProvider } from '../config/config';
import { RequestProvider } from '../request/request';
import { ResultSearchAdvancedModel, ResultProvider, RanglistSearchModel } from '../result/result';
import { StorageProvider } from '../storage-service/storage-service';

/*
  Generated class for the ValueProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/

export interface ValueModel {
  ident: string;
  condition: string;
}
export interface SinleValueModel {
  value: string;
}
export interface TextValueModel {
  text: string;
  value: string;
}
export interface BackgroundModel {
  id: number;
  value: string;
  lang: string;
  img: string;
  shade: string;
}

@Injectable()
export class ValueProvider {
  constructor(public request: RequestProvider, private translate: TranslateService, private strg: StorageProvider, public config: ConfigProvider, private resultProvider: ResultProvider) { }

  public async getEventSeachRange(cid: number): Promise<ValueModel[]> {
    return this.request.getApiSimple<ValueModel[]>('events/radius-conditions', { cid: cid + '' });
  }
  public async getEventSeachDistance(cid: number): Promise<ValueModel[]> {
    return this.request.getApiSimple<ValueModel[]>(`events/${cid}/distances`);
  }

  public async getEventSeachDate(cid: number): Promise<ValueModel[]> {
    return this.request.getApiSimple<ValueModel[]>('events/date-conditions', { cid: cid + '' });
  }

  async getEventDistancesByName(name: string): Promise<SinleValueModel[]> {
    return this.request.getApiSimple<SinleValueModel[]>(`events/${name}/distances`);
  }
  async getEventYearsByName(name: string): Promise<SinleValueModel[]> {
    return this.request.getApiSimple<SinleValueModel[]>(`events/${name}/years`);
  }
  async getEventTypesByName(name: string): Promise<SinleValueModel[]> {
    return this.request.getApiSimple<SinleValueModel[]>(`events/${name}/races`);
  }

  async getEventGrading(): Promise<SinleValueModel[]> {
    return this.request.getApiSimple<SinleValueModel[]>('event/racetypes');
  }

  async getEventVintagesFrom(name: string): Promise<SinleValueModel[]> {
    let lang = this.translate.getDefaultLang();
    return this.request.getApiSimple<SinleValueModel[]>('event/ages/from', { wertung: name + '', lang: lang });
  }

  async getEventVintagesTo(name: string): Promise<SinleValueModel[]> {
    let lang = this.translate.getDefaultLang();
    return this.request.getApiSimple<SinleValueModel[]>('event/ages/to', { wertung: name + '', lang: lang });
  }

  async getEventDetasWithResults(name: string, city: string): Promise<any> {
    return this.request.getApiSimple<any>('eresy', { ena: name, city: city });
  }


  getEventGradingTextCheck(grading: string, vintageFrom: string, vintageTo: string): Promise<SinleValueModel> {
    let params = new HttpParams({ fromObject: { altervon: vintageFrom, alterbis: vintageTo } });
    return new Promise(async (resolve, reject) => {
      this.request
        .get((await this.config.urlConfig()).baseUrl + 'event/racetype/check', { params: params })
        .timeout(20000)
        .toPromise()
        .then((value: SinleValueModel) => {
          if (value.value === '') {
            this.getEventGradingText(grading, vintageFrom, vintageTo).then(text => {
              resolve(text);
            });
          } else {
            reject(value);
          }
        })
        .catch(error => {
          console.log(error);
          throw 'cannot get checkwertung';
        });
    });
  }

  async getEventGradingText(grading: string, vintageFrom: string, vintageTo: string): Promise<SinleValueModel> {
    let lang = this.translate.getDefaultLang();
    return this.request.getApiSimple<SinleValueModel>('event/racetype', { wertung: grading, altervon: vintageFrom, alterbis: vintageTo, lang: lang });
  }

  async getProfileTitles(): Promise<SinleValueModel[]> {
    return this.request.getApiSimple<SinleValueModel[]>('users/salutations', {}, 2000, "event");
  }

  async getProfileTypes(): Promise<SinleValueModel[]> {
    return this.request.getApiSimple<SinleValueModel[]>('users/sport-types');
  }

  getCountries(): Promise<TextValueModel[]> {
    return this.request.getSimple<TextValueModel[]>('assets/data/value/country.json');
  }

  getStates(): Promise<TextValueModel[]> {
    return this.request.getSimple<TextValueModel[]>('assets/data/value/states.json');
  }


  getProfileBackgrounds(): Promise<any> {
    console.log('profile-background - 1');
    return new Promise<any>((resolve, reject) => {
      this.request.get("assets/data/value/backgrounds.json")
        .toPromise()
        .then(values => {
          resolve(values)
        }).catch((error) => {
          resolve([]);
        });
    });
  }

  async getClientEventNames(req: { cid: any }, _lid?: string): Promise<SinleValueModel[]> {
    let lid: number = _lid || (await this.config.config).client.lid || 0;
    console.log('lid: ', lid);

    if (!navigator.onLine) return this.strg.getSaved(Cache.EVENT_CLIENT_NAMES + lid).then(r => r);
    else return this.request.getApiSimple<SinleValueModel[]>(`user/${lid}/events-with-results/names`, { cid: req.cid }).then(r => {
      this.strg.saveData(r, Cache.EVENT_CLIENT_NAMES + lid);
      return r;
    });
  }

  async getClientEventDates(req: { ena: string; cid: any; lid?: string }, client: string = "g"): Promise<SinleValueModel[]> {
    req.lid = (await this.config.config).client.lid + '';
    if (!navigator.onLine) return this.strg.getSaved(Cache.EVENT_CLIENT_NAMES + req.ena + req.lid).then(r => r);
    else {
      if (client.includes("g")) {
        return this.request.getApiSimple<SinleValueModel[]>(`user/${req.lid}/events-with-results/dates?ena=${req.ena}&cid=${req.cid}`).then(r => {
          this.strg.saveData(r, Cache.EVENT_CLIENT_NAMES + req.ena + req.lid);
          return r;
        });
      } else {
        return this.request.getApiSimple<SinleValueModel[]>('presy', req).then(r => {
          this.strg.saveData(r, Cache.EVENT_CLIENT_NAMES + req.ena + req.lid);
          return r;
        })
      }
    }
  }

  async getClientEventDistances(req: { ena: string; dt: string; cid: any; lid?: string }, client: string = "g"): Promise<SinleValueModel[]> {
    let lid = (await this.config.config).client.lid + '';
    delete req.lid;
    if (!navigator.onLine) return this.strg.getSaved(Cache.EVENT_CLIENT_DISTANCES + req.ena + req.dt + req.lid).then(r => r);
    else {
      if (client.includes("g")) {
        return this.request.getApiSimple<SinleValueModel[]>(`user/${lid}/events-with-results/distances`, req).then(r => {
          this.strg.saveData(r, Cache.EVENT_CLIENT_DISTANCES + req.ena + req.dt + req.lid);
          return r;
        });
      } else {
        return this.request.getApiSimple<SinleValueModel[]>('presd', req).then(r => {
          this.strg.saveData(r, Cache.EVENT_CLIENT_DISTANCES + req.ena + req.dt + req.lid);
          return r;
        });
      }
    }
  }

  async getClientEventTypes(req: { ena: string; dt: string; dist: string; cid: any; lid?: string }, client: string = "g"): Promise<SinleValueModel[]> {
    let lid = (await this.config.config).client.lid + '';
    delete req.lid;
    if (!navigator.onLine) return this.strg.getSaved(Cache.EVENT_CLIENT_TYPES + req.ena + req.dt + req.dist + req.lid).then(r => r);
    else {
      if (client.includes("g")) {
        return this.request.getApiSimple<SinleValueModel[]>(`user/${lid}/events/racetypes`, req).then(r => {
          this.strg.saveData(r, Cache.EVENT_CLIENT_TYPES + req.ena + req.dt + req.dist + req.lid);
          return r;
        });
      } else {
        return this.request.getApiSimple<SinleValueModel[]>('prest', req).then(r => {
          this.strg.saveData(r, Cache.EVENT_CLIENT_TYPES + req.ena + req.dt + req.dist + req.lid);
          return r;
        })
      }
    }
  }

  getResultsRangList(search: ResultSearchAdvancedModel): Promise<any> {
    console.log('search: ', search);
    return new Promise<any>((resolve, reject) => {
      if (search.sw.length > 0 || search.dt.length > 0 || search.dist.length > 0 || search.t.length > 0) {
        this.getErgList(search).then(data => resolve(data));
        console.log('ENDPOINT: ath');

      } else {
        let searchModel: RanglistSearchModel = { eid: search.eid, page: search.page, start: search.start, limit: search.limit };
        this.resultProvider.getRangList(searchModel).then(data => resolve(data));
        console.log('ENDPOINT: resultlst');

      }
    });
  }

  async getEventDatesWithResults(ena: string, city: string): Promise<any> {
    if (!navigator.onLine) return this.strg.getSaved(Cache.EVENT_DATES_RESULTS + ena + city).then(r => r);
    else return this.request.getApiSimple<any>('eresy', { ena: ena, city: city }).then(r => {
      this.strg.saveData(r, Cache.EVENT_DATES_RESULTS + ena + city);
      return r;
    });
  }

  async getUserWithResults(ena: string, city: string, date: string): Promise<any> {
    if (!navigator.onLine) return this.strg.getSaved(Cache.USER_RESULTS + ena + city + date).then(r => r);
    else return this.request.getApiSimple<any>('eresd', { ena: ena, city: city, dt: date }).then(r => {
      this.strg.saveData(r, Cache.USER_RESULTS + ena + city + date);
      return r;
    })
  }

  async getUserEventTypeWithResults(ena: string, city: string, date: string, dist: string): Promise<any> {
    if (!navigator.onLine) return this.strg.getSaved(Cache.USER_EVENT_TYPE_RESULTS + ena + city + date + dist).then(r => r);
    else return this.request.getApiSimple<any>('erest', { ena: ena, city: city, dt: date, dist: dist }).then(r => {
      this.strg.saveData(r, Cache.USER_EVENT_TYPE_RESULTS + ena + city + date + dist);
      return r;
    })
  }

  async getErgList(params) {
    console.log('params: ', params);
    if (params.page === null) {
      params.page = 1 + '';
      params.limit = 25 + '';
      params.start = 0 + '';
    } else {
      params.page = parseInt(params.page) + 1 + '';
      params.start = parseInt(params.start) + 0 + '';
    }
    if (!navigator.onLine) return this.strg.getSaved(Cache.ATH_WITH_PARAMS + params.city + params.dt + params.dist + params.t + params.sw).then(r => r);
    else return this.request.getApiSimple<any>('event/results/list', { ena: params.ena, city: params.city, dt: params.dt, dist: params.dist, t: params.t, sw: params.sw, page: params.page, start: params.start, limit: params.limit }).then(r => {
      this.strg.saveData(r, Cache.ATH_WITH_PARAMS + params.city + params.dt + params.dist + params.t + params.sw);
      return r;
    })
  }

}



// WEBPACK FOOTER //
// /src/providers/value/value.ts